<template>
  <div>
    <el-row type="flex" justify="end" class="title-bar">
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-row>
      <el-table-wrapper ref="serviceTable" border :data="tableDatas" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;" :span-method="objectSpanMethod"
      :pagination="true" :remote="true" :total="tableTotal" :column-default="columnDefault" @condition-change="onChangeTable">
        <template #obj-name-slot="scope">
         <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{scope.row.objName}}</span>
         <span v-else>-</span>
        </template>
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import commonAPI from '@/api/performance/common';
import { mapGetters } from 'vuex';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { isNil, isEmpty, forEach } from 'lodash';
import { OBJDEFINE } from '@/constants/objdefine';
import { columnDefault } from '@/constants/table';
import { getDateToString } from '@/utils/date';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';

const elementTypeFilters = [];
forEach(OBJDEFINE, (value, key) => {
  elementTypeFilters.push({
    text: value,
    value: key,
  });
});

export default {
  name: 'WServicePerfTable',
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      tableDatas: [],
      columnDefault,
      tableTotal: 0,
      showSearchTool: false,
      columns: [
        { prop: 'objName', label: '서비스명', scopedSlot: 'obj-name-slot', searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'elementType', label: '구분', filterMultiple: false, filters: elementTypeFilters, formatter: this.convertObjDefineId },
        { prop: 'elementName', label: '장비명', searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'ipaddress', label: 'IP', searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'rscKeyNameList', remoteProp: 'event.rscKeyNameList', label: '구성항목', searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'eventCount', label: '발생 이벤트 수', formatter: this.eventCountFormatter },
      ],
      EMPTY_TEXT,
    };
  },
  computed: mapGetters(['selectedNode', 'selectedObjDefineIds', 'selectedObjDefineIdsForPhysical']),
  watch: {
    selectedNode: {
      handler() {
        if (this.$refs.serviceTable === undefined) {
          this.$nextTick(() => {
            this.$refs.serviceTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
            this.loadStore();
          });
        } else {
          this.$refs.serviceTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
          this.loadStore();
        }
      },
      immediate: true,
    },
    selectedObjDefineIdsForPhysical: {
      handler() {
        this.loadStore();
      },
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    loadStore() {
      if (this.active) {
        const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
        const tableParams = this.$refs.serviceTable.getParameter();
        const params = {
          managegroupIds: this.selectedNode.childManagegroupIds,
          managetypeId: 'SVC',
          objtypeId: this.selectedNode.objtypeId,
          treeType,
          ...tableParams,
        };
        if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
          params.objtypeIds = this.selectedObjDefineIdsForPhysical;
        }
        commonAPI
          .getPerformanceServiceGroupList(params)
          .then((result) => {
            if (result.data.success === true) {
              this.tableDatas = result.data.data;
              this.tableTotal = result.data.total;
            }
          });
      }
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [serviceStatusFormatter 서비스 상태 포맷]
     * @author {Yang}
     */
    serviceStatusFormatter(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return value > 0 ? '비정상' : '정상';
    },
    /**
     * [eventCountFormatter 이벤트 발생 건수 포맷]
     * @author {Yang}
     */
    eventCountFormatter(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : `${value} 개`;
    },
    /**
     * 테이블 날짜 포맷 설정
     * @author kimjy
     */
    convertDatetime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value);
    },
    /**
     * 테이블 장비 구분명 설정
     * @author Yang
     */
    convertObjDefineId(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return OBJDEFINE[value];
    },
    /**
     * 서비스명/항목 변경 시각 Row 병합
     * @author Yang
     */
    objectSpanMethod({ row, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 5) {
        if (!isNil(row.rowCount)) {
          return { rowspan: row.rowCount, colspan: 1 };
        }
        return { rowspan: 1, colspan: 0 };
      }
      return { rowspan: 1, colspan: 1 };
    },
    onChangeTable() {
      this.loadStore();
    },
    /**
     * 장비명 클릭 시 성능/운영 > 요약 탭으로 이동한다. [애플망고 SK]
     * @author Song
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickObjName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/group/perfinfo/components/ServicePerfTable.vue